<template>
  <BaseModal modal-content-class="game_modals">
    <div class="content">
      <h1>{{ $_translations.value.modal_resume_game_title }}</h1>

      <AvatarImage :src="authStore.userAvatar" />

      <p class="user_name">{{ authStore.userUsername }}</p>

      <p>
        {{ $_translations.value.modal_resume_game_description_pt1 }}<br>
        {{ $_translations.value.modal_resume_game_description_pt2 }}
      </p>

      <BaseButton @click:button="$emit('start:newGame')">
        {{ $_translations.value.modal_resume_game_button_proceed }}
      </BaseButton>
    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseButton from '@/components/button/BaseButton.vue';
import AvatarImage from '@/components/image/AvatarImage.vue';
import useAuthStore from '@/store/modules/auth.js';

defineEmits(['start:newGame']);

const authStore = useAuthStore();
</script>
